export default __webpack_public_path__ + "static/media/zannettou.54cd8728.jpg";